import { html, Html, View } from 'rune-ts';
import { ProductCard } from '../../ProductCard/ProductCard';

type ProductCardListItemData = {
  cardView: ProductCard;
};

export class ProductCardListItem extends View<ProductCardListItemData> {
  public readonly product_id: number;
  public readonly ordered_at: Date | null;
  private readonly cardView: ProductCard;

  constructor(data: ProductCardListItemData) {
    super(data);
    this.cardView = data.cardView;
    this.product_id = data.cardView.data.id;
    this.ordered_at = data.cardView.data.ordered_at ?? null;
  }

  protected override template(): Html {
    return html`<li>${this.cardView}</li>`;
  }

  public fadeIn() {
    return this.cardView.fadeIn();
  }
}
